'use client'

import { HTMLProps } from 'react'
import clsx from 'classnames'
import { Text } from '@/shared/ui'
import style from './sticky-event.module.scss'

type Stages = { title: string; description: string }[]

interface StickyEventsProps extends HTMLProps<HTMLUListElement> {
  stages: Stages
}

export const StickyEvents = ({ className, stages }: StickyEventsProps) => {
  return (
    <ul className={clsx(style.container, className)}>
      {stages.map(({ title, description }, index) => {
        return (
          <li className={style.item} key={index}>
            <Text color="dark" type="h1" tagName="h5">
              {title}
            </Text>
            <Text color="dark-040" type="d" tagName="span">
              {description}
            </Text>
          </li>
        )
      })}
    </ul>
  )
}
